// MUST be first — registers the Syncfusion license before any component
// module is evaluated. See the EnterpriseEmail main.tsx comment.
import "@/lib/registerSyncfusion";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initSuiteAppearance } from "@athavita/ui-theme";
import { App } from "./App";
import { initSyncfusion } from "@/lib/syncfusion";
import { installSyncfusionDarkMode } from "@/lib/syncfusionDarkMode";
import { oidcConfig } from "@/auth/authConfig";
import "./styles/globals.css";

const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } }
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in index.html");

void initSyncfusion();
// Suite look (mode, accent, top-bar style) — this app's own look, else the
// suite's — applied before the first render and kept in step with other apps.
initSuiteAppearance("sheets");
// Ribbon, menus and grid headers follow the suite's dark toggle (`.e-dark-mode`).
installSyncfusionDarkMode();

ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
        <AuthProvider {...oidcConfig}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </QueryClientProvider>
        </AuthProvider>
    </React.StrictMode>
);
